import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import SecondaryCTA from './SecondaryCTA';
import SecondaryCTAV2 from '../SecondaryCTA.pp_benefits';

export default withFeatureBranch({ pp_benefits: SecondaryCTAV2 })(SecondaryCTA);
